export default {
    category:{
        loading:false,
        data:null,
        error:null,
    },
};